
Greenmile.HoursOfService = Greenmile.HoursOfService || {};

Greenmile.HoursOfService.Utils = {

    getEventTypeName: function (eventType) {

        var error = null, name = "";

        try {

            if (eventType === "ON_DUTY") {

                name = "onDuty";

            } else if (eventType === "OFF_DUTY") {

                name = "offDuty";

            } else if (eventType.indexOf("DRIVING") !== -1) {

                name = "driving";

            } else if (eventType.indexOf("BREAK") !== -1) {

                name = "break";

            } else if (eventType.indexOf("WAIT") !== -1) {

                name = "wait";

            } else if (eventType.indexOf("LUNCH") !== -1) {

                name = "lunch";

            }

            return name;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on get event type name");
            error.console();

        }

    },

    positionByType: function (hosEventType) {

        var position = 0;

        if (hosEventType === "OFF_DUTY") {
            position = 1;
        }

        if (hosEventType.indexOf("BREAK") !== -1) {

            position = 2;

        }

        if (hosEventType.indexOf("LUNCH") !== -1) {

            position = 3;

        }

        if (hosEventType.indexOf("WAIT") !== -1) {

            position = 4;

        }

        if (hosEventType.indexOf("DRIVING") !== -1) {

            position = 5;

        }

        if (hosEventType === "ON_DUTY") {
            position = 6;
        }

        return position;

    },

    getArrayEventTypeToHOSLayerControl: function () {

        var i18n     = Monet.I18n,
            onDuty   = i18n.getResourcesByKey("HOSLayerControl.label.onDuty"),
            driving  = i18n.getResourcesByKey("HOSLayerControl.label.driving"),
            wait     = i18n.getResourcesByKey("HOSLayerControl.label.wait"),
            lunch    = i18n.getResourcesByKey("HOSLayerControl.label.lunch"),
            hosBreak = i18n.getResourcesByKey("HOSLayerControl.label.hosBreak"),
            offDutty = i18n.getResourcesByKey("HOSLayerControl.label.offDuty");


        var hosEventTypes = [
            {
                label: onDuty,
                value: this.getEventTypeName("ON_DUTY")
            },
            {
                label: driving,
                value: this.getEventTypeName("DRIVING")
            },
            {
                label: wait,
                value: this.getEventTypeName("WAIT")
            },
            {
                label: lunch,
                value: this.getEventTypeName("LUNCH")
            },
            {
                label: hosBreak,
                value: this.getEventTypeName("BREAK")
            },
            {
                label: offDutty,
                value: this.getEventTypeName("OFF_DUTY")
            }

        ];

        return hosEventTypes;

    },
    getResourceByEventType: function (eventType) {

        var label;

        switch (eventType) {

            case  'ON_DUTY':
                label = 'Greenmile.HOSMap.popup.label.ON_DUTY';
                break;
            case  'OFF_DUTY':
                label = 'Greenmile.HOSMap.popup.label.OFF_DUTY';
                break;
            case  'BREAK_START':
                label = 'Greenmile.HOSMap.popup.label.BREAK_START';
                break;
            case  'BREAK_END':
                label = 'Greenmile.HOSMap.popup.label.BREAK_END';
                break;
            case  'LUNCH_START':
                label = 'Greenmile.HOSMap.popup.label.LUNCH_START';
                break;
            case  'LUNCH_END':
                label = 'greenmile.HOSMap.popup.label.LUNCH_END';
                break;
            case  'DRIVING_START':
                label = 'Greenmile.HOSMap.popup.label.DRIVING_START';
                break;
            case  'DRIVING_END':
                label = 'Greenmile.HOSMap.popup.label.DRIVING_END';
                break;
            default :
                label = '';

        }

        return label;

    },

    adjustMapSize : function () {
        var selectorLogBook = "#HosMapDisplay #logBook",
        selectorMapContainerHOS = "#HosMapDisplay #mapContainerHOS";

        const container = document.querySelector(selectorLogBook);
        const mapContainerHOS = document.querySelector(selectorMapContainerHOS);

        let height = container.style.display != "none" ? container.style.height : 0 ;
        mapContainerHOS.style.bottom = height;

        Monet.Session.HOS.map.invalidateSize();
    },

    mergeHOSByDriver : function (driverId, data) {
        const dataSerialized = {
            driver: { id: driverId },
            events: []
         };
         
         data.forEach(hos => {
            dataSerialized.events = [...dataSerialized.events, ...hos.events];
         });

         return dataSerialized;
    },

    mergeSameDriversHOSByRoute : function (data) {
        let dataSerialized = [];

        data.forEach(hosByDriver => { 
            const previousIndex = dataSerialized.length - 1;
            const returnTheSameDriverHOS = () => {
                dataSerialized = [...dataSerialized, hosByDriver];
            };
            
            if (previousIndex >= 0) {
                const previousHOSByDriver = dataSerialized[previousIndex];
                const isTheSameDriver = hosByDriver.driver.id === previousHOSByDriver.driver.id;

                if (isTheSameDriver) {
                    previousHOSByDriver.events = [...previousHOSByDriver.events, ...hosByDriver.events];
                } else {
                    returnTheSameDriverHOS();
                }

            } else {
                returnTheSameDriverHOS();
            }
        });

        return dataSerialized;
    }
};
